import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const workflowsNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.workflows_tracker, {
      displayName: 'Tracker',
      icon: SolIcon.asm_tracker,
    }),
    SolNavbarItem.of(PrototypeRouteId.workflows_drp, {
      displayName: 'Digital Risk Protection',
      icon: SolIcon.asm_drp,
      children: [
        SolNavbarItem.of(PrototypeRouteId.workflows_dark_web, {
          displayName: 'Dark Web',
          icon: SolIcon.asm_dark_web,
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.workflows_assets, {
      displayName: 'Assets',
      icon: SolIcon.asm_assets,
      children: [
        SolNavbarItem.of(PrototypeRouteId.workflows_domain_discovery, {
          displayName: 'Domain discovery',
          icon: SolIcon.asm_domain_discovery,
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
